<template>
  <div class="container">
      <AlertTemplate :setting="setting"/>
<!--      <a-descriptions v-if="items.data">-->
<!--        <a-descriptions-item label="Legal Name">{{ items.data.legalName }}</a-descriptions-item>-->
<!--      </a-descriptions>-->

      <div class="flex justify-between items-center">
        <div class="self-center">
          <div v-if="setting.templates && setting.templates.avatar" class="flex space-y-logo">
<!--            <a-avatar shape="square" :src="setting.templates.avatar" :size="120" style="box-shadow: rgb(0 0 0 / 10%) 0 1px 0 0"/>-->
<!--            <img :src="setting.templates.avatar" width="120" height="75" alt="avatar" class="object-contain"/>-->
            <img :src="setting.templates.avatar" alt="avatar" class="object-contain" style="width: 10rem;"/>
          </div>
          <a-avatar v-else :size="120" icon="user" />
        </div>
        <div v-if="items.record" class="" style="text-align: right">
          <a-descriptions :column="1">
            <a-descriptions-item label="Invoice Number">{{ items.record.factor_no || '__' }}</a-descriptions-item>
            <a-descriptions-item label="Invoice Date">{{ setDateFormat(items.record.issue_date) }}</a-descriptions-item>
            <a-descriptions-item label="Payment Due">{{ setDateFormat(items.record.due_date) }}</a-descriptions-item>
            <a-descriptions-item v-if="items.record.matters && items.record.matters.length" label="Our Reference">{{ items.record.matters[0].reference_code }}</a-descriptions-item>
          </a-descriptions>
        </div>
      </div>
      <a-divider />
      <!--   COMPONENTS   -->
      <DescriptionTblBill 
        :items="items"
        :setting="setting"
        @closeModal="closeModal"
        @amountDueChanged="$emit('amountDueChanged', $event)"
      />
  </div>
</template>

<script>
import DescriptionTblBill from "./components/DescriptionTblBill";
import mixin from '@/views/mixin/mixin'

export default {
  name: "Template",
  mixins:[mixin],
  components:{
    DescriptionTblBill,
    AlertTemplate
  },
  props:{
    items:{
      type     : Object,
      required : true,
    },
    setting:{
      type     : Object,
      required : false,
    }
  },
  methods: {
    goToPayment() {
      const _record = this.items.record
      this.$router.push({ path: '/billing/record-payment', query: { client_id: _record.to_contact.id,type: _record.type }})
    },
    closeModal(val) {
      this.$emit('finalClose',val)
    },
  },
  mounted() {

  }
}

import AlertTemplate from "@/views/template/components/AlertTemplate";
</script>

<style>
  @import "./style.css";
</style>
